package com.macrofocus.high_d.distributions

class DefaultDistributionsController<Row, Column, Value, Bin>(view: DistributionsView<Row,Column,Value,Bin>? = null) : AbstractDistributionsController<Row, Column, Value, Bin>(view) {
}